import styled from 'styled-components';
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
// import S3Client from 'aws-s3';
import Select from 'react-select';
import Alert from 'react-s-alert';

import { Button } from './Button';

const PresentationImage = styled.div`
  width: 120px;
  height: 70px;
  border-radius: 3px;
  background-image: url('${(props) => props.src}');
  background-size: cover;
  display: inline-block;
  margin: 0 10px;
`;

export class AWSUpload extends Component {
  constructor(props) {
    super(props);
    this.handleDrop = this.handleDrop.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.state = {
      files: [],
      urls: [],
      id: '',
      upload: false,
    };
  }

  handleDrop(files) {
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.setState((prevState) => ({
          files: [...prevState.files, e.target.result],
          urls: [...prevState.urls, file.preview]
        }));
      }
      reader.readAsDataURL(file);
    })
  }

  async handleUpload() {
    await this.setState({upload: true});
    if (this.state.id) {
      if (this.state.files.length) {
        this.props.handleUpload(this.state.files, this.state.id);
      } else {
        Alert.warning('Select images', {timeout: 2000});
      }
    } else {
      Alert.warning('Select an measurement', {timeout: 2000});
    }
    await this.setState({upload: false});
  }

  handleSelect(e) {
    this.setState({id: e.value});
  }

  render() {
    const { urls } = this.state;

    return (
      <div style={{padding: '20px'}}>
        <Select
          onChange={this.handleSelect}
          options={this.props.measurement.map((item) => ({value: item.id, label: item.id}))}
        />
        <Dropzone
          onDrop={this.handleDrop}
          accept="image/jpeg, image/png, image/jpg"
          style={{
            maxWidth: '900px',
            width: '100%',
            margin: '20px auto',
            border: '2px dashed #ccc',
            padding: '80px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {!urls.length ?
            <span>
              Drop some files here, or click to select files to upload only one file
            </span> :
            <span>
              {urls.map((item) => (
                <PresentationImage
                  key={`key-${item}`}
                  src={item}
                />
              ))}
            </span>
          }
        </Dropzone>
        <hr />
        <Button
          block
          disable={this.state.upload}
          onClick={this.handleUpload}
        >
          UPLOAD
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AWSUpload.js